export default __webpack_public_path__ + "static/assets/1b0577264cf81069ce720e24c2866702.svg";